module.exports = __webpack_public_path__ + "img/main_large.e3b44e22.webp";